export enum RightHandSystem { Piano = 'piano', Button = 'button' }